import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AssociationMember } from '../../../../../../models/association';
import { AccountService } from '../../../../../../services/account/account.service';
import { InboxService } from '../../../../../../services/inbox/inbox.service';
import { AssociationService } from '../../../../../../services/association/association.service';
import { CallbackResult, CallbackResultStatus, dateStringFromISO8601 } from '../../../../../../utils';
import { ReviewAssociationJoinRequestModalComponent } from './modals/review-association-join-request-modal/review-association-join-request-modal.component';


@Component({
  selector: 'app-inbox-association-join-requests',
  templateUrl: './inbox-association-join-requests.component.html',
  styleUrls: ['./inbox-association-join-requests.component.css']
})
export class InboxAssociationJoinRequestsComponent implements OnInit {

  public joinRequests: AssociationMember[];

  public loadingJoinRequests = true;

  public serverError: number = null;

  public modalResult: CallbackResult = null;

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public dateStringFromISO8601 = dateStringFromISO8601;
  public CallbackResultStatus = CallbackResultStatus;

  constructor(
    public accountService: AccountService,
    private associationService: AssociationService,
    private inboxService: InboxService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().can_manage_members) {
      return;
    }

    this.loadJoinRequests();
  }

  public joinRequestsPresent() {
    return this.joinRequests && (this.joinRequests.length > 0);
  }

  public loadJoinRequests() {
    this.loadingJoinRequests = true;

    this.associationService
      .getAssociationMembers(
        1,
        3000,
        {
          exclude_old: true,
          has_pending_application: true,
          application_is_hidden_from_inbox: false
        }
      )
      .then(result => {
        this.joinRequests = result.results;
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.accountService.logout();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingJoinRequests = false; });
  }

  public openReviewJoinRequestModal(joinRequest: AssociationMember) {
    this.modalResult = null;

    const modalRef = this.modalService.open(ReviewAssociationJoinRequestModalComponent);
    modalRef.componentInstance.associationId = joinRequest.association_id;
    modalRef.componentInstance.associationMemberId = joinRequest.id;
    modalRef.componentInstance.showHideOption = true;
    modalRef.componentInstance.savedCallback = (result: CallbackResult) => {
      this.modalResult = result;
      this.loadJoinRequests();
    };
  }
}
